import type { DeutscheBahnServiceClass, DeutscheBahnServiceClassOption } from "./types";

/** Route segment, API transport-type segment and transfer-hub `type`. */
export const DEUTSCHE_BAHN_SLUG = "deutsche-bahn";

/** Header / breadcrumb label when provider info has not loaded yet. */
export const DEUTSCHE_BAHN_DISPLAY_NAME = "Deutsche Bahn";

/** Path after the language segment. */
export const DEUTSCHE_BAHN_PATH_SUFFIX = `/transport/${DEUTSCHE_BAHN_SLUG}`;

/** Relative confirmation path used by PaymentModal and the paid-booking redirect. */
export const DEUTSCHE_BAHN_CONFIRMATION_PATH = `transport/${DEUTSCHE_BAHN_SLUG}/confirmation`;

export const DEUTSCHE_BAHN_SERVICE_CLASS_OPTIONS: readonly DeutscheBahnServiceClassOption[] = [
  {
    value: 1,
    labelKey: "transport.deutscheBahn.firstClassBtn"
  },
  {
    value: 2,
    labelKey: "transport.deutscheBahn.secondClassBtn"
  }
] as const;

export const DEFAULT_DEUTSCHE_BAHN_SERVICE_CLASS: DeutscheBahnServiceClass = 2;

/** Maximum passengers per booking. The "+ add" button is hidden once the list reaches it. */
export const DEUTSCHE_BAHN_MAX_PASSENGERS = 5;
